import { render, staticRenderFns } from "./StockSlipHistory.vue?vue&type=template&id=2252cafa&scoped=true"
import script from "./StockSlipHistory.vue?vue&type=script&lang=js"
export * from "./StockSlipHistory.vue?vue&type=script&lang=js"
import style0 from "./StockSlipHistory.vue?vue&type=style&index=0&id=2252cafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252cafa",
  null
  
)

export default component.exports